import React from 'react';

import moment from 'moment';
import axios from 'axios';
import './style.css';
import { connect } from 'react-redux';
import { liveFeedClearMessages } from '../../redux/actions/index';
import Storage from '../Storage';
import { InputGroup, Button, Spinner } from 'react-bootstrap';
import { __API_FEED_ROOM__, __API_FEED_FORUM__, __APIURLVIRTUALEXPO__, __APIKCURL__ } from '../../consts/consts';
import 'moment/locale/es-do';
import IntlMessages from '../../helpers/IntlMessages';
import Utils from '../Utils';


class LiveFeed extends React.Component {

    constructor(props) {
        super(props);
        this.state = { messageText: '', historicalFeed: null, isLoading: true };

    }

    async postMessage(event) {
        const { roomId, forumId } = this.props;
        const { messageText } = this.state;
        const endpointURL = `${__APIURLVIRTUALEXPO__}Feed/Send`;
        const formData = {
            idEvent: Storage.getIdEvent(),
            roomId,
            forumId,
            message: messageText
        };

        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Credentials': 'true',
                //La siguiente linea hace la magia de autenticar con el token!
                'Authorization': 'bearer ' + Storage.getJwtToken()
            },
        };

        try {
            await axios.post(endpointURL, options, formData)

        } catch (error) {
            console.error(error.response);
        } finally {
            this.setState({ messageText: '' });
            this.scrollToBottom();
            if (event != null) {
                event.preventDefault();
            }
        }
    }

    onWordChange(e) {
        this.setState({ messageText: e.target.value });
    }
    scrollToBottom() {

        if (this.messagesEnd != null) {
            console.log("MessagesEnd: ", this.messagesEnd)
            document.getElementById("ref-scrollMessages").parentNode.scrollTop = document.getElementById('ref-scrollMessages').offsetTop;

        }
    }

    componentDidMount() {

        this.getHistoricalFeed();

    }
    async getHistoricalFeed() {
        let url = "";
        if (Number(this.props.roomId) > 0) //Si vale NAN o 0 no lo tomo
            url = __API_FEED_ROOM__ + this.props.roomId;
        if (Number(this.props.forumId) > 0)
            url = __API_FEED_FORUM__ + this.props.forumId;

        const options = {
            url: url + "/" + Storage.getPersonRegistrationCode(),
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Credentials': 'true'
            }
        }

        await axios(options).then(response => {
            this.setState({
                isLoading: false, historicalFeed: response.data.map(feed => {

                    return {
                        roomId: Number(feed.idRoom),
                        forumId: Number(feed.idForum),
                        message: feed.message,
                        date: feed.postedDate,
                        personName: feed.senderName,
                        id: feed.id,
                        pictureId: feed.personalImageId
                    }
                }
                )
            })
            this.props.liveFeedClearMessages();
            this.scrollToBottom();
        }).catch(error => {
            console.log("Error")
            console.log(error)
        })
    }

    componentDidUpdate(prevProps) {

        if (prevProps.roomId != this.props.roomId || prevProps.forumId != this.props.forumId) {
            this.getHistoricalFeed();
        }
        this.scrollToBottom();
    }

    preventEnter(event) {
        if (event.keyCode === 13) {
            console.log("PREVENTED")
            event.preventDefault()
        }
    }



    render() {

        moment.locale('es-ar');
        if (this.state.isLoading) {
            return (<Spinner></Spinner>);
        }
        return (
            <div className="live-feed-container" style={{ height: this.props.height }}>
                <div id="messageContainer" className="live-feed-message-container">

                    {
                        this.state.historicalFeed.concat(this.props.liveFeed.filter(o => o.roomId == this.props.roomId ||
                            o.forumId == this.props.forumId))
                            .map(
                                (message) => (

                                    <div key={message.id} className="live-feed-message-item">
                                        <div className="div-messages">
                                            <div className="div-message-pictureId">
                                                <img className="message-pictureId" alt="Profile" src={Utils.getProfilePictureOrUnknown(message.pictureId)} />
                                            </div>
                                            <div className="live-feed-message-hour">
                                                {moment.utc(message.date).fromNow()}
                                            </div>
                                            <div className="live-feed-message-user">
                                                {`${message.personName}: ${message.message}`}
                                            </div>
                                        </div>
                                    </div>
                                )
                            )
                    }
                    <div id="ref-scrollMessages" ref={(el) => { this.messagesEnd = el; }}> </div>
                    <div style={{ clear: "both" }}> </div>
                </div>
                <form onSubmit={(event) => this.postMessage(event)} >
                    <InputGroup className="mb-3">
                        <input className=" form-control" value={this.state.messageText} onChange={(e) => this.onWordChange(e)} placeholder={this.props.locale == "es" ? "Escribe tu comentario en vivo" : "Write your live comment"} onKeyDown={(ev) => this.preventEnter(ev)} />
                        <InputGroup.Append >
                            <Button outline color="secondary" onClick={() => this.postMessage()}>
                                <IntlMessages id="dashboards.event-wall-comment" />
                            </Button>
                        </InputGroup.Append>
                    </InputGroup>

                </form>
            </div>


        );
    }

}

const mapStateToProps = state => {
    return {
        liveFeed: state.liveFeed.liveFeed,
        locale: state.settings.locale
    };

};
export default connect(
    mapStateToProps,
    { liveFeedClearMessages }
)(LiveFeed);
